import { DataBean } from "../DataBean";

export class CreateMovementTax extends DataBean {



    public async createOBFinancialMovementTax(idFinancialMovementTax: any, financialMovementDate: any, rpIDDocument: any, rpDocumentDate: any, externalConsecutive: any, description: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.AccountantDocument_createOBFinancialMovementTax_Number_java.util.Date_Number_java.util.Date_Number_String_Number", [idFinancialMovementTax, financialMovementDate, rpIDDocument, rpDocumentDate, externalConsecutive, description, idEmployee]);
    }

}